import robot from '../resources/media/robot-2x-multiple-tenants.png';
import infoIcon from '../resources/media/icon-help-black.svg';
import externalLinkIcon from '../resources/media/external_link.svg';

import React, { useState } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import {
    DOC_CENTER_REGION_PATH,
    DOC_CENTER_URL,
    MARKETING_LINK,
} from '../common/constants';
import CigHeader from './CigHeader';
import TenantSelectionTable from './TenantSelectionTable';
import {isServiceCmUri} from '../common/utils';


export function TenantSelectionPage({tenants, redirectToTenantFn}) {
    const [selectedRecord, setSelectedRecord] = useState()

    const launchingTenant = (e) => {
        e.preventDefault();
        if (selectedRecord != null) {
            redirectToTenantFn(selectedRecord.tenantId, selectedRecord.hostname, selectedRecord.uiMode);
        }
    }

    const setSelectedTenantRecord = (record) => {
        setSelectedRecord(record);
    }

    return (
        <div id="tenant-picker-container" className="tw-m-auto tw-bg-gray-100 tw-h-screen tw-w-screen">
            <CigHeader cmMode={isServiceCmUri()} showLogout={true} ></CigHeader>
            <div id="tenant-picker-body" className="tw-flex tw-justify-center tw-w-full tw-bg-gray-100">
                <div className="tw-block">
                    <div id="message-header" className="tw-font-normal tw-text-2xl tw-block tw-mt-64px tw-mx-160px">
                        Pardon the interruption, we need your help choosing which tenant to use:
                    </div>
                    <div className="tw-flex tw-mt-48px">
                        <div className="tw-ml-160px tw-pt-38px">
                            <div id="tenant-picker-robot" className="tw-flex tw-justify-center tw-ml-80px">
                                <div id="picker-robot" className="tw-w-full">
                                    <img src={robot} alt="robot" width={305}/>
                                </div>
                            </div>
                        </div>
                        <div className="tw-ml-32px" style={{width: '55%'}}>
                            <div className="tw-bg-white">
                                <div className="tw-mx-24px tw-pt-38px tw-pb-38px">
                                    <div id="table-picker-msg-box" className="tw-mb-16px tw-text-14px tw-bg-white tw-block">
                                        You have multiple tenants associated with your NetApp console, we don’t know which one to use.
                                    </div>
                                    <div id="table-available-tenants" className="tw-bg-white tw-mb-16px tw-block tw-text-16px tw-font-semibold">
                                        Available Tenants ({tenants.length})
                                    </div>
                                    <div id="table-tenant-picker" data-testid="table-tenant-picker" >
                                        <TenantSelectionTable id="tenant-table" tenants={tenants} setSelectedDataFn={setSelectedTenantRecord} data-testid="tenant-table"/>
                                    </div>
                                    <button id="choose-env-button"
                                        className={classnames('tw-border tw-px-20px tw-rounded-md tw-text-14px tw-mt-16px tw-py-8px',
                                            {'tw-text-gray-500 tw-border-gray-300 tw-bg-gray-100 hover:tw-bg-gray-100 disabled': _.isEmpty(selectedRecord),
                                                'tw-text-white tw-border-netapp-blue tw-bg-banner hover:tw-bg-blue-500': !_.isEmpty(selectedRecord)
                                            })}
                                        onClick={launchingTenant} >
                                        Go to Selected Tenant
                                    </button>
                                    <div id="edition-table-doc-link" className="tw-block tw-pt-16px tw-text-14px">
                                        <span className="tw-inline">* See</span>
                                        <a className="tw-text-link tw-inline tw-pl-5px" href={MARKETING_LINK} target="_blank" rel="noopener noreferrer">
                                            editions table
                                            <img className="tw-inline tw-items-center tw-pb-5px tw-pl-5px" src={externalLinkIcon} width="20px" alt=">" />
                                        </a>
                                    </div>
                                    <div id="region-table-doc-link" className="tw-block tw-text-14px">
                                        <span className="tw-inline">** See</span>
                                        <a className="tw-text-link tw-inline tw-pl-5px" href={DOC_CENTER_URL + DOC_CENTER_REGION_PATH}  target="_blank" rel="noopener noreferrer">
                                            regions information
                                            <img className="tw-inline tw-items-center tw-pb-5px tw-pl-5px" src={externalLinkIcon} width="20px" alt=">" />
                                        </a>
                                    </div>
                                    <div id="note-container" className="tw-bg-note tw-mt-24px tw-mr-64px tw-text-base" >
                                        <div className="tw-flex tw-inline-block tw-pt-16px tw-pl-16px">
                                            <span className="tw-flex-initial tw-mr-6px"><img src={infoIcon} alt="I" width="24px"></img></span>
                                            <span id="note-title" className="tw-flex-auto tw-font-semibold tw-pt-2px">
                                                Manual tenant selection can be required for the following reasons:
                                            </span>
                                        </div>
                                        <div id="note-text" className="tw-inline-block tw-pl-56px tw-pb-20px">
                                            <li>You use more than one NetApp console instance.</li>
                                            <li>You have been invited to an additional NetApp Data Infrastructure Insights Tenant.</li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

TenantSelectionPage.displayName = 'TenantSelectionPage';
export default TenantSelectionPage;